import type { Ref } from "react";
import { useRef } from "react";
import type { ScrollViewProps } from "react-native";
// eslint-disable-next-line no-restricted-imports
import { ScrollView as RNScrollView } from "react-native";
import Animated from "react-native-reanimated";
import { withUnistyles } from "react-native-unistyles";

import { mergeRefs, ScrollProvider } from "$src/core/contexts/scroll";

const ScrollView = ({
  ref: forwardedRef,
  ...props
}: ScrollViewProps & { ref?: Ref<RNScrollView> }) => {
  const ref = useRef<RNScrollView | null>(null);

  return (
    <ScrollProvider scrollRef={ref}>
      <RNScrollView {...props} ref={mergeRefs(ref, forwardedRef)} />
    </ScrollProvider>
  );
};

const AnimatedScrollViewComponent = ({
  ref: forwardedRef,
  ...props
}: ScrollViewProps & { ref?: Ref<Animated.ScrollView> }) => {
  const ref = useRef<Animated.ScrollView | null>(null);

  return (
    <ScrollProvider scrollRef={ref}>
      <Animated.ScrollView {...props} ref={mergeRefs(ref, forwardedRef)} />
    </ScrollProvider>
  );
};

export const AnimatedScrollView = withUnistyles(
  AnimatedScrollViewComponent,
) as unknown as typeof Animated.ScrollView;

export default withUnistyles(ScrollView) as unknown as typeof RNScrollView;
